import { Switch as SwitchIcon } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import autoBind from 'react-autobind';

import CurrencySelector from '../../../common/CurrencySelector';
import styles from '../../../resources/static/less/comparison-components.module.less';

const createClassNames = (classNames) =>
  classNames.map((className) => `${styles[className]}`).join(' ');

// FIXME This randomly chooses a currency that's not the same one as "selected"?, it should be deterministic ideally
function getTopCurrency(selectedCurrency) {
  const topCurrencies = ['GBP', 'EUR', 'USD', 'AUD'];
  const index = Math.floor(Math.random() * (topCurrencies.length - 1));
  return topCurrencies.filter((c) => c !== selectedCurrency)[index];
}

function getRouteAttributesToUpdate(type, selectedCurrency, currencyToCheck) {
  const attributesToUpdate = { [type]: selectedCurrency };
  if (selectedCurrency === currencyToCheck) {
    const currencyRoute = {
      sourceCurrency: 'targetCurrency',
      targetCurrency: 'sourceCurrency',
    };
    attributesToUpdate[currencyRoute[type]] = getTopCurrency(selectedCurrency);
  }
  return attributesToUpdate;
}

class RouteSelector extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      search: '',
    };
  }

  onSelectChange(type) {
    return (selectedCurrencyProfile) => {
      this.updateCurrenciesRoute(type, selectedCurrencyProfile.code);
    };
  }

  updateCurrenciesRoute(type, selectedCurrency) {
    const { sourceCurrency, targetCurrency, onRouteChange } = this.props;
    const route = {
      sourceCurrency: () => getRouteAttributesToUpdate(type, selectedCurrency, targetCurrency),
      targetCurrency: () => getRouteAttributesToUpdate(type, selectedCurrency, sourceCurrency),
    };

    const attributesToUpdate = route[type]();
    this.setState({ search: '' });
    onRouteChange({ ...attributesToUpdate });
    return attributesToUpdate;
  }

  handleSwapCurrencies() {
    const { onRouteChange, sourceCurrency, targetCurrency } = this.props;
    onRouteChange({ sourceCurrency: targetCurrency, targetCurrency: sourceCurrency });
  }

  render() {
    const { sourceCurrency, targetCurrency } = this.props;
    const { search } = this.state;
    return (
      <div
        className={createClassNames([
          'm-b-5',
          'd-flex',
          'flex-column',
          'flex-row-md',
          'align-items-center',
        ])}
      >
        <div className={createClassNames(['size-1-of-1'])}>
          <CurrencySelector
            type="sourceCurrency"
            currencyCode={sourceCurrency}
            style={styles}
            search={search}
            onSelectChange={this.onSelectChange}
          />
        </div>
        {/* eslint-disable-next-line */}
        <div className={createClassNames(['d-flex'])} onClick={this.handleSwapCurrencies} >
          <SwitchIcon size={24} className={styles['tw-swap-icon']} />
        </div>
        <div className={createClassNames(['size-1-of-1'])}>
          <CurrencySelector
            type="targetCurrency"
            currencyCode={targetCurrency}
            style={styles}
            search={search}
            onSelectChange={this.onSelectChange}
          />
        </div>
      </div>
    );
  }
}

RouteSelector.propTypes = {
  sourceCurrency: PropTypes.string.isRequired,
  targetCurrency: PropTypes.string.isRequired,
  onRouteChange: PropTypes.func.isRequired,
};

export default RouteSelector;
